import { apiCall, ApiConfig } from '../../config/api'
import { SettingsData } from '../../interfaces/Settings/settings'
import { getSettingsAction, SettingsActionAsync } from '../actions/settingsActions'
import { retry, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse } from 'axios'
import { GET_SETTINGS } from '../types/settingsActionsTypes'

const RETRY_COUNT = 3
const RETRY_DELAY = 1000

export function* getSettingsAsync(action: SettingsActionAsync) {
  try {
    const url = new URL(`${ApiConfig.SettiingsApi}/typeSetting/${action.typeSettingId}`)
    if (action.productOriginId != null) {
      url.searchParams.set('productOriginId', String(action.productOriginId))
    }
    const { status, data }: AxiosResponse<SettingsData[]> = yield retry(
      RETRY_COUNT,
      RETRY_DELAY,
      apiCall,
      'GET',
      url.toString()
    )
    if (status === 200) {
      yield put(getSettingsAction(data, undefined, action.typeSettingId))
    }
  } catch (error) {
    yield put(getSettingsAction([], '', action.typeSettingId))
  }
}

export function* watchGetSettingsAsync() {
  yield takeEvery(GET_SETTINGS, getSettingsAsync)
}
